module.exports = __webpack_public_path__ + "static/media/sf-trial-2-wrong.e3c6f7dd.mp3";